var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm._isMobile ? 'mt88' : 'warpMt'},[_c('img',{class:_vm._isMobile ? 'bannerStyleM' : 'bannerStylePc',attrs:{"src":_vm._isMobile ? 'https://cdn.youjiajk.com/productBannerMobile2.png' : 'https://cdn.youjiajk.com/productBannerPC_YS_2.png'}}),_vm._v(" "),(!_vm._isMobile)?_c('productPc'):_c('productMobile')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cee196e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product.vue
// module id = null
// module chunks = 